import { Component, OnInit } from '@angular/core';
import { UserService } from '../shared/user.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})
export class RegisterComponent implements OnInit {

  policyCheckbox: boolean = false;

  constructor(public service:UserService, private toastr: ToastrService) { }

  ngOnInit() {
    this.service.formModel.reset();
  }

  onSubmit() {
    this.service.register().subscribe(
      (res: any) => {
        if (res.succeeded) {
          this.service.formModel.reset();
          this.toastr.success('Na podany adres został wysłany powitalny e-mail ze szczegółowymi informacjami', 'Założono nowe konto!');
        } else {
          res.errors.forEach(element => {
            switch (element.code) {
              case 'DuplicateUserName':
                this.toastr.error('Ten e-mail jest już zajęty','Rejestracja nie powiodła się');
                break;

              default:
              this.toastr.error(element.description,'Rejestracja nie powiodła się');
                break;
            }
          });
        }
      },
      err => {
        console.log(err);
      }
    );
  }
}
